module.exports = __webpack_public_path__ + "static/media/rajasthan.a6f3a890.png";